/* eslint-disable no-underscore-dangle */
import { useState, useEffect } from 'react';

function _getWindowSize() {
  const { innerWidth, innerHeight } = window;
  return { width: innerWidth, height: innerHeight };
}

export default function useWindowSize() {
  const [windowSize, setWindowSize] = useState(_getWindowSize());

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(_getWindowSize());
    }
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return windowSize;
}
